import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const VisionRiskWarningCard = ({ show }) => {
  const navigate = useNavigate();
  if (!show) return null;

  return (
    <div
      className="mb-8 rounded-lg border-2 border-danger/60 bg-bone px-5 py-5"
      role="alert"
    >
      <div className="flex gap-3">
        <ExclamationTriangleIcon className="w-6 h-6 text-danger shrink-0 mt-0.5" />
        <div className="flex-1">
          <h2 className="font-display text-h3 text-primary mb-2">
            Your Visions may be at risk
          </h2>
          <p className="text-body text-secondary mb-4">
            Aura can no longer verify your income or savings progress. Reconnect your
            account or update your Cashflow to keep your plan on track.
          </p>
          <button
            type="button"
            className="btn-primary"
            onClick={() => navigate('/account-settings')}
          >
            Reconnect Account
          </button>
        </div>
      </div>
    </div>
  );
};

export default VisionRiskWarningCard;
